const configs = {
  GOOGLE_MAP_KEY: 'AIzaSyDeUW6mWM3d85ZTwaUOYnL_OFWSog2mNkA',
  SENTRY_DSN:
    'https://15843e47a4bb4be6abce6c3d907f757e@o222561.ingest.sentry.io/5368803',
};

export default configs;
